<template>
  <sidebar-layout>
    <template v-if="petition.successful">
      <success-banner />
      <hr class="my-4">
    </template>

    <!-- This anchor is used on mobile by an in-page link to jump to the form. -->
    <a name="signature-form" />

    <sign-petition />
  </sidebar-layout>
</template>

<script>
import { mapState } from 'vuex'
import SidebarLayout from '../../campaign-action-shared/sidebar-layout'
import SignPetition from './sign-petition'
import SuccessBanner from './success-banner'

export default {
  components: {  SidebarLayout, SignPetition, SuccessBanner },

  computed: {
    ...mapState(['petition'])
  }
}
</script>
